/**
 * @generated SignedSource<<902e9e54d81c18c4b1438880199d018d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandBuilds_brand$data = {
  readonly appConfig: {
    readonly androidAppBuild: string;
    readonly androidAppVersion: string;
    readonly appName: string;
    readonly iosAppBuild: string;
    readonly iosAppVersion: string;
    readonly " $fragmentSpreads": FragmentRefs<"InternBuildConfigPanel_appConfig">;
  };
  readonly id: string;
  readonly " $fragmentType": "InternBrandBuilds_brand";
};
export type InternBrandBuilds_brand$key = {
  readonly " $data"?: InternBrandBuilds_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandBuilds_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandBuilds_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppBuild",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidAppVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidAppBuild",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InternBuildConfigPanel_appConfig"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "f58b405944f562d4fe2a6d5480dd993b";

export default node;
